import React from 'react';

export function SelectProfile({error, name, title, value, children, disabled, onChange}) {

  return <div className="profile__group">
    <p className="profile__help help">{title}</p>
    <select name={name}
            className={"profile__select select" + (error ? " select--error" : "")}
            value={value}
            disabled={disabled}
            onChange={onChange}>
      {children}
    </select>
  </div>;
}
